module.exports = __webpack_public_path__ + "img/img5711_comp3.a7aa54ea.jpg";